var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"espacio"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"col-color",attrs:{"lg":"6"}},[_c('h4',[_vm._v("Nuestro propósito")]),_c('h2',[_vm._v("“Elevar el alma de la mujer mexicana a sentirse libre, única, guapa y segura”")])]),_c('b-col',{staticClass:"col-img",attrs:{"lg":"6"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }